
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      pdfPathSD: '',
      pdfPathSDP: '',
    }
  },
  computed: {
    ...mapGetters('unidade', ['unidadeInformation']),
    pathDPN() {
      if (this.unidadeInformation.unidade === 'senhadigital.com.br') {
        return this.pdfPathSD
      } else if (this.unidadeInformation.unidade === 'senhadigitalplus.com.br') {
        return this.pdfPathSDP
      } else {
        return ''
      }
    },
  },
}
